<template>
  <!--节-->
  <div id="examsection">
    <h2 class="title">
      <a @click="back()" class="prev"></a>
      章节练习
    </h2>
    <div class="main">
      <!--
      <a href="" class="cc">
        <div class="left">
          <h4>第一章：名称</h4>
          <p>直播时间：2018.10.20-2018.10.22</p>
        </div>
        <div class="right">
          答题
        </div>
      </a>
      -->
      <router-link :to="{name: 'ExamTest', query: {exam_id: item.exam_id,chapter_id: item.chapter_id}}" class="cc" v-for="(item, index) in sectionData.info" :key="index">
        <div class="left">
          <h4>{{item.name}}</h4>
          <p>章节知识点简介</p>
        </div>
        <div class="right">
          答题
        </div>
      </router-link>
    </div>
    <div class="bg"></div>
  </div>
</template>

<script>
export default {
  name: 'ExamSection',
  data () {
    return {
      examId: this.$route.query.exam_id ? this.$route.query.exam_id : 35,
      page: 1,
      limit: 100,
      sectionData: {}
    }
  },
  mounted () {
    this.getExamSection()
  },
  methods: {
    getExamSection () {
      let data = {
        exam_id: this.examId,
        page: this.page,
        limit: this.limit
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_question_section_list',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          if (res.data.errcode === 200) {
            this.sectionData = res.data.data
          } else if (res.data.errcode === -1) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            // this.$router.push({name: 'PwdLogin'})
          } else {
            console.log(res.data.message)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    back () {
      if (window.history.length <= 1) {
        this.$router.push({path: '/'})
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style scoped lang="stylus">
  #examsection
    @import "../../assets/stylus/examHead"
    .main
      padding: 0 .4rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      a.cc
        position: relative
        display: flex
        justify-content: space-between
        align-items: center
        width: 6.7rem
        height: 1.6rem
        background-color: #fff
        padding: .4rem .4rem .4rem .56rem
        margin-top: .32rem
        overflow: hidden
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        -webkit-border-radius: .2rem
        -moz-border-radius: .2rem
        border-radius: .2rem
        &::before
          content: ""
          position: absolute
          top: .4rem
          left: -.16rem
          display: inline-block
          width: .32rem
          height: .8rem
          background-color: #1E81F2
          -webkit-border-radius: .16rem
          -moz-border-radius: .16rem
          border-radius: .16rem
        .left
          width: 3.8rem
          h4
            margin: 0 0 .02rem
            font-size: .32rem
            color: #333
            font-weight: 500
          p
            font-size: .24rem
            color: #999
        .right
          width: 1.2rem
          height: .48rem
          line-height: .48rem
          background-color: #FF6445
          font-size: .24rem
          color: #fff
          text-align: center
          -webkit-border-radius: .24rem
          -moz-border-radius: .24rem
          border-radius: .24rem
    .bg
      position: fixed
      top: 0
      left: 0
      z-index: -1
      width: 100%
      height: 100%
      background-color: #F7F7F7
</style>



// WEBPACK FOOTER //
// src/components/exam/ExamSection.vue